import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function InfoIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: [_jsx("path", { clipRule: "evenodd", d: "M12 21a9 9 0 110-18 9 9 0 010 18z", stroke: primaryFillColor }), _jsx("path", { fill: primaryFillColor, d: "M10.809 11h2.383v7h-2.383z" }), _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3z", fill: primaryFillColor })] }));
}
//# sourceMappingURL=Info.js.map